.container {
  composes: -expand from "./util.module.css";
  object-fit: contain;
}
